import {
  SLIDABLE_PAGINATED_CLEAN_STATE,
  SLIDABLE_PAGINATED_RELOAD,
  SLIDABLE_PAGINATED_SET_LOAD_ITEMS,
  SLIDABLE_PAGINATED_SET_LOAD_ITEMS_FAILURE,
  SLIDABLE_PAGINATED_SET_LOAD_ITEMS_SUCCESS,
} from '@Pages/RetroSynthesis/components/RsSlidablePaginated/constants';

export const initialState = {
  lastLoadedPage: null,
  totalPages: 0,
  loadedPages: [],
  isLoading: false,
  items: [],
  totalElements: 0,
  partialLastPageLoaded: false,
  reloadToItem: null,
  error: null,
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SLIDABLE_PAGINATED_CLEAN_STATE: {
      return { ...initialState };
    }
    case SLIDABLE_PAGINATED_SET_LOAD_ITEMS: {
      return { ...state, isLoading: true, reloadToItem: 0 };
    }
    case SLIDABLE_PAGINATED_RELOAD: {
      return { ...initialState, reloadToItem: action.payload };
    }
    case SLIDABLE_PAGINATED_SET_LOAD_ITEMS_SUCCESS: {
      const { result, params } = action.payload;
      const maxPageSize = params.size;
      const { page } = params;
      if (result.number === state.lastLoadedPage) {
        // already loaded
        return state;
      }
      let allItems;
      if (page > state.lastLoadedPage || !state.totalElements) {
        allItems = state.items.concat(result.content);
      } else {
        allItems = result.content.concat(state.items);
      }
      return {
        ...state,
        partialLastPageLoaded: result.numberOfElements > maxPageSize,
        totalElements: result.totalElements,
        lastLoadedPage: result.number,
        loadedPages: result.numberOfElements > maxPageSize ? [result.number, result.number + 1] : state.loadedPages.concat([result.number]),
        totalPages: result.totalPages,
        items: allItems,
        isLoading: false,
        error: null,
      };
    }
    case SLIDABLE_PAGINATED_SET_LOAD_ITEMS_FAILURE: {
      Logger.error('RsSlidablePaginated component loading items error: ', action.payload);
      return { ...state, isLoading: false, error: action.payload };
    }
    default: {
      return state;
    }
  }
}
